import { BackednResponse } from "@shared/lib/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { PURCHASES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";
import { IPayments } from "../types";

export interface GetPaymentsParams {
  pageNo?: number;
  limit?: number;
  searchQuery?: string;
  brandIds?: string[];
  subTypes?: string[];
}

export function useGetPayments(params: GetPaymentsParams) {
  const {
    data,
    isLoading,
    error,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery<BackednResponse<IPayments>>({
    queryKey: [...PURCHASES_QUERY_KEY, params],
    queryFn: ({ pageParam = 1 }) =>
      AccountingService.getPayments({
        ...params,
        pageNo: pageParam as number,
        limit: 10,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.data.pagination.hasNextPage) {
        return lastPage.data.pagination.currentPage + 1;
      }
      return undefined;
    },
  });
  const payments = data?.pages?.flatMap((page) => page.data.data);

  return {
    payments,
    error,
    isFetching: isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
